export const BRAND_NAME = 'Xtorage';
export const BRAND_TAGLINE = 'fulfillment solutions';
export const BRAND_DOMAIN = process.env.NEXT_PUBLIC_SITE_DOMAIN || 'x-torage.com';
export const BRAND_URL = process.env.NEXT_PUBLIC_SITE_URL || `https://${BRAND_DOMAIN}`;
export const BRAND_EMAIL_DOMAIN = BRAND_DOMAIN;
export const BRAND_SUPPORT_EMAIL = `hello@${BRAND_DOMAIN}`;
export const BRAND_OPERATOR_EMAIL = `operator@${BRAND_DOMAIN}`;

export const brandAssets = {
  logo: {
    horizontal: {
      dark: '/brand/logo/logo-horizontal-dark.svg',
      light: '/brand/logo/logo-horizontal-light.svg',
    },
    vertical: {
      dark: '/brand/logo/logo-vertical-dark.svg',
      light: '/brand/logo/logo-vertical-light.svg',
    },
    wordmark: {
      dark: '/brand/logo/wordmark-dark.svg',
      light: '/brand/logo/wordmark-light.svg',
    },
  },
  mark: {
    dark: '/brand/iconos/icon-mark-dark.svg',
    light: '/brand/iconos/icon-mark-light.svg',
  },
  favicon: '/favicon.ico',
  appleTouchIcon: '/apple-touch-icon.png',
} as const;

export type BrandSurface = 'dark' | 'light';
export type LogoVariant = 'horizontal' | 'vertical' | 'mark' | 'wordmark';

export function getBrandAsset(
  variant: LogoVariant,
  surface: BrandSurface = 'dark'
): string {
  if (variant === 'mark') return brandAssets.mark[surface];
  return brandAssets.logo[variant][surface];
}
